import { User, UserOverview, UserCreate } from 'projects/flow-gui-access/views/middlewares/users'

module.exports = [
  {
    path: '/users',
    exact: true,
    component: UserOverview,
    admin: true
  },
  {
    path: '/users/create',
    exact: true,
    component: UserCreate,
    admin: true
  },
  {
    path: '/users/:userid',
    exact: true,
    component: User
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/users.js